// extracted by mini-css-extract-plugin
module.exports = {"root":"Input_root__-FmV1","number":"Input_number__1bABK","search":"Input_search__1YYxk"};